import { SymbolLeaderboardRanking } from '@flipster/apis/v1/symbol-leaderboard/types';
import { RankingCard } from '@flipster/features/src/shared/community-feed/ranking-card';
import { useRawSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

interface SymbolLeaderboardProps {
  symbol: string;
  rankings: SymbolLeaderboardRanking[];
  css?: Styles;
}

export const SymbolLeaderboard = ({ symbol, rankings, css: cssProps }: SymbolLeaderboardProps) => {
  const { instrumentsKeyBySymbol } = useRawSnapshotSpec();
  const { displayShortName } = instrumentsKeyBySymbol?.[symbol] ?? {};
  return (
    <div className={css(stack.raw({ gap: 12, minW: 360 }), cssProps)}>
      <div className={stack()}>
        <p className={css({ textStyle: 'Text/S/Strong' })}>{displayShortName}</p>
        <p className={css({ textStyle: 'Text/L/Strong' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Top_PnL_traders' />
        </p>
        <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-1' })}>
          <FormattedMessage id='Autogen_common.r251126.s_over_last_7_days' />
        </p>
      </div>
      <div>
        {rankings.map((ranking, idx) => (
          <RankingCard key={ranking.userProfileId} ranking={ranking} rank={idx + 1} />
        ))}
      </div>
    </div>
  );
};
